/**
 * Copyright © 2026 Adnuntius AS.
 * UI-Router state declarations.
 */
import {Ng2StateDeclaration} from '@uirouter/angular';
import {StateDeclarationBuilder, AdnRouterHelperApi} from '../routing/state-utils';
import {stateTitleView} from '../common/directives/html/state-title.component';
import {MappingRoutePageComponent} from './mapping-route-page.component';


export function mappingStates(_adnRouterHelper: AdnRouterHelperApi): Ng2StateDeclaration[] {
  const states = new StateDeclarationBuilder();
states.add('app.dat-map.mappings', {
          url: '/mappings',
          views: {
            'content@app': {
              component: MappingRoutePageComponent
            },
            'title@app': stateTitleView()
          },
          data: {
            title: 'Mappings'
          }
        });
  return states.build();
}